import { useForm } from "react-hook-form";
import { ModalFinalizarCriativoStyled } from "./style";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { JustificativaObrigatorio } from "../../../schemas/campanha";
import { yupResolver } from "@hookform/resolvers/yup";

export const ModalFinalizarCriativo = ({ state, criativo, buscarCriativo }) => {
  const { register, handleSubmit, formState: { errors }, } = useForm({
    resolver: yupResolver(JustificativaObrigatorio),
  })

  function onSubmitFunction(value) {
    value.status = "finalizado"

    api.patch(`/criativo/${criativo.id}`, value)
      .then((response) => {
        buscarCriativo()
        state(false)
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  }

  return (
    <ModalFinalizarCriativoStyled >
      <form onSubmit={handleSubmit(onSubmitFunction)} className="div-body">
        <span onClick={() => state(false)} className="close">
          X
        </span>
        <h2>Confirme a Finalização do Pedido</h2>
        <h3>Após a finalização, não será possível realizar alterações ou adicionar novas informações ao pedido.</h3>
        <h3>Se necessário, adicione uma justificativa ou informe o número da PO.</h3>
        <textarea {...register("justificativa")} />
        {errors.justificativa && (
          <span className="input-error-cadastro">
            {errors.justificativa.message}
          </span>
        )}
        <div className="buttons">
          <button className="finalizar">finalizar</button>
          <button onClick={() => state(false)} className="cancelar">cancelar</button>
        </div>
      </form>
    </ModalFinalizarCriativoStyled>
  );
};